import { render, staticRenderFns } from "./addItemReleaseViewList.vue?vue&type=template&id=a3494860&scoped=true"
import script from "./addItemReleaseViewList.vue?vue&type=script&lang=js"
export * from "./addItemReleaseViewList.vue?vue&type=script&lang=js"
import style0 from "./addItemReleaseViewList.vue?vue&type=style&index=0&id=a3494860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3494860",
  null
  
)

export default component.exports